<div class="form-container">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="4">
        <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;">  {{editAuthorityData?'Add':'Edit'}} Authority </div>
      </ion-col>
      <ion-col size="8" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row> 
    <!-- authority-form.component.html -->
    <form [formGroup]="authorityForm" style="margin: 10px;">
      <ion-row>
        <ion-col size="6" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Allocating Department<span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="allocatingDep" placeholder="" maxlength="255"  (keyup)="checkMaxLength(authorityForm.get('allocatingDep')?.value)"
            />
            <mat-error *ngIf="hasError('allocatingDep', 'required')">Allocating Department is required</mat-error>
          </mat-form-field>
        </ion-col> 
       
        <ion-col size="6" class="mt-10">
      
          <div class="formLabelRegularfs16 mb-5">
            Select Employee<span class="red-cl">&nbsp;*</span>
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select"  formControlName="employeeId"
             >
             <mat-option [value]="item.id" *ngFor="let item of allListingEmployee" class="custom-option">
              {{ item.firstName }} {{item.lastName}}
            </mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('employeeId', 'required')">Employee name is required</mat-error>
          </mat-form-field>
        </ion-col>

      </ion-row>
      <ion-row>
        <ion-col size="12" class="text-right mt-10">
          <button class="back_btn fs-14 fs_12ForMobile" (click)="cancelData()">Cancel</button>
          <button type="button" class="add_btn fs-14 fs_12ForMobile ml-10"[class.disabled]="authorityForm.invalid"
           [style.background-color]="buttonColorName" (click)="editAuthorityData?onSubmit():updateAutority()">
         {{editAuthorityData?'Add':'Update'}}
          </button>
        </ion-col>
      </ion-row>
    </form>

  </div>
</div>
